
<div class="loading-indicator-background">

</div>
<video id="vid" autoplay="" loop="" muted="" playsinline="" class="loading-video" >
  <source src="/assets/video/loading.mov" type="video/quicktime; codecs=hvc1" />
  <source src="/assets/video/loading.webm" type="video/webm">
</video>